import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_grid_table_cell = _resolveComponent("grid-table-cell")
  const _component_grid_table_row = _resolveComponent("grid-table-row")

  return (_openBlock(), _createBlock(_component_grid_table_row, { class: "gfu-table__row" }, {
    default: _withCtx(() => [
      _createVNode(_component_grid_table_cell, {
        class: "_tal _flexb30 _flexb20--l",
        "data-qa": "payment-history:Date"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($props.item.completionDate), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_grid_table_cell, {
        class: "_tal gfu-table__cell--grow _flexwrap",
        "data-qa": "payment-history:PaymentMethod"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($options.paymentName), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_grid_table_cell, {
        width: 30,
        class: "_pa-0",
        "data-qa": "payment-history:Amount"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($props.item.amount), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}